export function getUrl() {
	if (process.env.NODE_ENV == 'development') {
		return `http://${process.env.STRAPI_DATABASE_NAME}:${process.env.STRAPI_PORT}`
	} else {
		return `https://${process.env.API_DOMAIN}`
	}
}

export const header = {
	'Content-Type': 'application/json',
	'Authorization': `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
}